module.exports = __webpack_public_path__ + "static/standProjMain-37d35e67ab804cf59a470bd17e2ee797.png";